import { Component, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SVGIconModule } from '@progress/kendo-angular-icons';
import { LabelModule } from '@progress/kendo-angular-label';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';

@Component({
  selector: 'ui-bestaetigung',
  imports: [FormsModule, LabelModule, ButtonsModule, SVGIconModule, DialogsModule, IndicatorsModule],
  template: `
    @if (sichtbar()) {
      <kendo-dialog [title]="ueberschrift()" (close)="close()" [minWidth]="250" [width]="450">
        <p style="margin: 30px; text-align: center;">
          <b>{{ bezeichnung() }}</b>
        </p>
        <kendo-dialog-actions>
          @if (nurBestaetigung()) {
            <button kendoButton name="btnJa" (click)="action($event)" class="btnGruen">Ok</button>
          } @else {
            <button kendoButton name="btnJa" (click)="action($event)" class="btnRot">Ja</button>
            <button kendoButton name="btnNein" (click)="action($event)" class="btnBlau">Nein</button>
          }
        </kendo-dialog-actions>
      </kendo-dialog>
    }
  `,
})
export class UiBestaetigungComponent {
  bezeichnung = input.required<string>();
  ueberschrift = input<string>('Bitte bestätigen:');
  buttonClick = output<boolean>();
  sichtbar = model<boolean>(false);

  nurBestaetigung = input<boolean>(false);

  protected close(): void {
    // event.preventDefault();
    this.sichtbar.set(false);
  }

  protected action(event: any): void {
    if (event.target.innerText == 'Ja' || event.target.innerText == 'Ok') {
      this.buttonClick.emit(true);
    }
    this.sichtbar.set(false);
    event.preventDefault();
    event.stopPropagation();
  }
}
